import MaterialTable from "material-table";
import React from "react";
import { connect } from "react-redux";
import { GET_PROJECT_SUPERVISOR } from "../graphql/queries";
import { LinearProgress } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { optionTableProject } from "./OptionTable.component";

const TableSPV = ({ columnData }) => {
  const history = useHistory();
  const { data, loading, refetch } = useQuery(GET_PROJECT_SUPERVISOR, {
    pollInterval: 1000,
  });

  if (loading) return <LinearProgress />;

  const plannerData = data.findAllProjectSupervisor
    .slice()
    .filter(({status}) => status === "approve" || status === "reject" || status === "submit" || status === "return")
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map((o) => ({ ...o }));
  return (
    <div className="max-width-section m-5">
    <MaterialTable
      columns={columnData}
      data={plannerData}
      title="Project List from Planner"
      actions={[
        {
          onClick: (event, rowData) =>
            history.push({
              pathname: `/dashboard/supervisor/project-list/${rowData.id}`,
            }),
        },
      ]}
      options={optionTableProject}
      components={{
        Action: (props) => (
          <Button
            onClick={(event) => props.action.onClick(event, props.data)}
            variant="outline-dark"
            className="mx-auto"
            style={{ textTransform: "none" }}
            size="small"
          >
            View Detail
          </Button>
        ),
      }}
    />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    columnData: state.spv.columnDataProject,
  };
};

export default connect(mapStateToProps, null)(TableSPV);
